import { DetailsListLayoutMode, SelectionMode } from '@fluentui/react';
import { useAffectedProductInfiniteApi } from 'api/affectedProduct';
import { ICveNumber } from 'api/apiTypes';
import { ApiSchemaName } from 'api/metadata/useMetadataInfiniteApi';
import { useMetadataStructuredApi } from 'api/metadata/useMetadataStructuredApi';
import {
  onRenderUpdateListColumn,
  defaultColumnKeyList,
} from 'component/layout/Update/allUpdateColumnList';
import { SearchListConnectedToReactQuery } from 'component/SearchListConnectedToReactQuery';
import { columnListUpdate } from './columnListUpdate';
import { useSecurityUpdateCardFilterSettings } from './useSecurityUpdateCardFilterSettings';

/**
 * Component that renders the "Updates" tab of the "Security Updates" list
 * for a vulnerability.
 */

export const VulnSecurityUpdatesListUpdatesTab = ({
  cveNumber,
}: ICveNumber) => {
  const { data: metadata, isLoading: isMetadataLoading } =
    useMetadataStructuredApi(ApiSchemaName.affectedProduct);
  const tableName = `vulnerability-${cveNumber}`;

  const filterSettings = useSecurityUpdateCardFilterSettings({
    cveNumber,
  });

  return (
    <SearchListConnectedToReactQuery
      tableName={tableName}
      allColumnList={columnListUpdate}
      filterSettings={filterSettings}
      detailsListProps={{
        layoutMode: DetailsListLayoutMode.justified,
        compact: true,
        selectionMode: SelectionMode.none,
        onRenderItemColumn: onRenderUpdateListColumn,
      }}
      hideDatePicker
      defaultColumnKeyList={defaultColumnKeyList}
      useInfiniteApiQuery={useAffectedProductInfiniteApi}
      metadata={metadata}
      isMetadataLoading={isMetadataLoading}
    />
  );
};
